import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import { Mail, Phone, MapPin, Clock, Download, ArrowUp, Sparkles } from 'lucide-react';
import Logo from '../Components/Images/Bada school logo.png';

export default function Footer() {
  const [contacts, setContacts] = useState([]);
  const [downloads, setDownloads] = useState([]);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/GetContactInfo`)
      .then(res => setContacts(Array.isArray(res.data) ? res.data : []))
      .catch(err => {
        console.error(err);
        setContacts([]);
      });

    axios.get(`${API_BASE_URL}/GetDownloadDropDown`)
      .then(res => setDownloads(Array.isArray(res.data) ? res.data : []))
      .catch(err => {
        console.error(err);
        setDownloads([]);
      });

    const checkScrollTop = () => {
      if (window.scrollY > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const schoolContact = (Array.isArray(contacts) && contacts[0]) || {
    Email: 'technoschoolbsp@gmail.com',
    PhoneNo: '8982397404',
    Location: 'Daya Vihar, Ganesh Nagar, Bilaspur (C.G.) - 495 004'
  };

  return (
    <footer style={{ backgroundColor: '#ffffff', color: 'var(--text-primary)', borderTop: '4px solid var(--primary-color)', paddingTop: '64px', paddingBottom: '32px', fontFamily: 'Quicksand', position: 'relative' }}>

      {/* Wave svg divider decoration */}
      <div style={{ position: 'absolute', top: '-24px', left: 0, right: 0, height: '24px', overflow: 'hidden', zIndex: 1 }}>
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ width: '100%', height: '100%', fill: '#ffffff' }}>
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" />
        </svg>
      </div>

      <div className="page-container-wide" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '32px', marginBottom: '48px' }}>

          {/* Brand Column */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
              <img src={Logo} alt="VTS Logo" style={{ height: '44px', width: '44px', borderRadius: '50%', border: '2px solid var(--primary-color)' }} />
              <h3 style={{ fontSize: '1.25rem', color: 'var(--text-primary)', margin: 0, fontWeight: 700, fontFamily: 'Poppins' }}>Vamshee Techno</h3>
            </div>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.92rem', lineHeight: '1.6', marginBottom: '20px' }}>
              A joyful and nurturing space where learning is an inspiring journey. "Keep Going, Keep Growing."
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <a href="https://www.youtube.com/channel/UCsQisHLHtKsIbPFQRpZUZew" target="_blank" rel="noreferrer" style={socialIconStyle}>
                <i className="fa-brands fa-youtube" />
              </a>
              <a href="https://www.instagram.com/technoschool_bsp/" target="_blank" rel="noreferrer" style={socialIconStyle}>
                <i className="fa-brands fa-instagram" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={columnTitleStyle}>Quick Explore</h4>
            <ul style={listStyle}>
              <li><Link to="/" style={linkStyle}>Home</Link></li>
              <li><Link to="/Notice" style={linkStyle}>Notice Board</Link></li>
              <li><Link to="/Gallery" style={linkStyle}>School Gallery</Link></li>
              <li><Link to="/Contact" style={linkStyle}>Contact Us</Link></li>
              <li><Link to="/Academics" style={linkStyle}>Academics Program</Link></li>
              <li><Link to="/Admissions" style={linkStyle}>Admissions Form</Link></li>
              <li><button onClick={() => document.getElementById('trigger-login-modal')?.click()} style={{ ...linkStyle, background: 'transparent', border: 'none', padding: 0, textAlign: 'left', font: 'inherit', cursor: 'pointer' }}>Admin Portal</button></li>
            </ul>
          </div>

          {/* Downloads */}
          <div>
            <h4 style={columnTitleStyle}>Downloads</h4>
            {!Array.isArray(downloads) || downloads.length === 0 ? (
              <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>No downloads lists available.</p>
            ) : (
              <ul style={listStyle}>
                {downloads.map((item, idx) => (
                  <li key={idx}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      href={item?.Link ? item.Link.replace("/edit", "/export?format=pdf") : ''}
                      download
                      target="_blank"
                      rel="noreferrer"
                      style={{ ...linkStyle, display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                    >
                      <Download size={14} style={{ color: 'var(--primary-color)' }} /> {item?.Name || 'Document'}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Contacts */}
          <div>
            <h4 style={columnTitleStyle}>Contact VTS</h4>
            <ul style={{ ...listStyle, gap: '16px' }}>
              <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                <MapPin size={18} style={{ color: 'var(--accent-coral)', flexShrink: 0, marginTop: '2px' }} />
                <span style={{ fontSize: '0.88rem', color: 'var(--text-secondary)' }}>{schoolContact.Location}</span>
              </li>
              <li style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Phone size={18} style={{ color: 'var(--accent-green)', flexShrink: 0 }} />
                <a href={`tel:${schoolContact.PhoneNo}`} style={{ ...linkStyle, fontSize: '0.88rem' }}>+91 {schoolContact.PhoneNo}</a>
              </li>
              <li style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Mail size={18} style={{ color: 'var(--primary-color)', flexShrink: 0 }} />
                <a href={`mailto:${schoolContact.Email}`} style={{ ...linkStyle, fontSize: '0.88rem' }}>{schoolContact.Email}</a>
              </li>
              <li style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <Clock size={18} style={{ color: 'var(--accent-purple)', flexShrink: 0 }} />
                <span style={{ fontSize: '0.88rem', color: 'var(--text-secondary)' }}>Mon - Sat: 8:00 AM - 2:00 PM</span>
              </li>
            </ul>
          </div>

          {/* Maps Embed Column */}
          <div>
            <h4 style={columnTitleStyle}>Find Us On Map</h4>
            <div style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--border-color)', height: '180px', boxShadow: 'var(--shadow-sm)' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1784137941673!6m8!1m7!1sfdfayezMc84Ixw1ZODKYOQ!2m2!1d22.04986423236506!2d82.18294995763385!3f179.8344071999588!4f-9.259780278810254!5f0.7820865974627469"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Google Maps Location"
              />
            </div>
          </div>

        </div>

        <hr style={{ borderColor: 'var(--border-color)', margin: '32px 0' }} />

        {/* Bottom */}
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '16px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
          <span>© {new Date().getFullYear()} Vamshee Techno School. All rights reserved.</span>
          <div style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
            <Link to="/Contact" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Privacy Policy</Link>
            <Link to="/Contact" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>Terms & Conditions</Link>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>Designed with <Sparkles size={12} style={{ color: 'var(--secondary-color)' }} /> for Kids</span>
          </div>
        </div>

        {/* Developer Badge */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
          <a href="https://vinayvamsheeresume.vercel.app/" target="_blank" rel="noreferrer" className="developed-by-badge">
            <Sparkles size={14} style={{ marginRight: '6px', color: '#ff5e62' }} />
            <span className="badge-text">Developed by VinayVamshee</span>
            <Sparkles size={14} style={{ marginLeft: '6px', color: '#33ccff' }} />
          </a>
        </div>
      </div>

      {/* Floating Back to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          style={scrollTopButtonStyle}
          title="Scroll to Top"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </footer>
  );
}

// Inline Styles
const columnTitleStyle = {
  fontSize: '0.95rem',
  fontWeight: '700',
  color: 'var(--text-primary)',
  textTransform: 'uppercase',
  letterSpacing: '1.5px',
  marginBottom: '20px',
  fontFamily: 'Poppins'
};

const listStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px'
};

const linkStyle = {
  color: 'var(--text-secondary)',
  textDecoration: 'none',
  fontSize: '0.92rem',
  transition: 'color 0.2s ease',
  cursor: 'pointer'
};

const socialIconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  backgroundColor: 'var(--border-color)',
  color: 'var(--text-primary)',
  transition: 'all 0.2s ease',
  textDecoration: 'none'
};

const scrollTopButtonStyle = {
  position: 'fixed',
  bottom: '30px',
  right: '30px',
  backgroundColor: 'var(--primary-color)',
  color: '#ffffff',
  width: '46px',
  height: '46px',
  borderRadius: '50%',
  border: 'none',
  boxShadow: 'var(--shadow-lg)',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999,
  transition: 'all 0.2s'
};

// Styles injections
const footerStyles = document.createElement('style');
footerStyles.innerHTML = `
  footer a:hover {
    color: var(--primary-dark) !important;
  }
  button[style*="position: fixed"]:hover {
    transform: translateY(-4px) scale(1.05) !important;
    background-color: var(--primary-dark) !important;
  }
  @keyframes textShine {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  .developed-by-badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 16px;
    border-radius: 20px;
    border: 1px solid var(--border-color);
    background: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    text-decoration: none !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
    transition: all 0.3s ease;
  }
  .developed-by-badge:hover {
    transform: translateY(-2px);
    border-color: var(--primary-color);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.05) !important;
  }
  .developed-by-badge .badge-text {
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color), var(--primary-color));
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: textShine 6s linear infinite;
  }
`;
document.head.appendChild(footerStyles);
